// extracted by mini-css-extract-plugin
module.exports = {"square":"Vision_square__1UtZQ"};